module.exports = __webpack_public_path__ + "static/media/naked.b3f7a7b3.png";